import { fromBD, toBD } from '@/helpers/plate'
import Auto from '@/datas/Autos'
import Repository from './Repository'

const action = 'auto-mobiles'
const actionMobile = '/pages/trucks/with-payments'

export default {
  getList(page = false, status) {
    let pagination = '?expand=user,added_org,master-approve'
    let filter = ''

    if (page) {
      pagination += '&page=' + page
    }
    if (status) {
      filter = `&master_approve_status=${status}`
    }

    return Repository.get(action + pagination + filter)
  },
  getListMobile(page = false, org_id, search) {
    let params = ''

    if (page) {
      params += '?page=' + page
    }
    if (org_id) {
      params += (params ? '&' : '?') + 'user_org_id=' + org_id
    }
    if (search) {
      params += (params ? '&' : '?') + 'search=' + toBD(search)
    }

    return Repository.get(actionMobile + params)
  },
  getAuto(params) {
    return Repository.get(action + params)
  },
  getAutoTypes() {
    return Repository.get('vehicle-types')
  },
  findAutoByInnAndAproveContract(inn) {
    return Repository.get(action + '?inn=' + inn + '&')
  },
  findAutoByCarrierInn(payload, expand) {
    return Repository.get(`${action}?${payload}&${expand}`)
  },
  update(id, auto) {
    return Repository.put(action + '/' + id, auto.serialize()).then(
      response => response,
    )
  },
  approve(id) {
    return Repository.put(action + '/' + id, { is_approve: 1 })
  },
  addCar(plate, data = {}) {
    let auto = new Auto()

    auto.set('plate', fromBD(plate))
    for (let k in data) {
      auto.set(k, data[k])
    }

    return Repository.post(action, auto.serialize()).then(response => response)
  },
  updateAutoFromData(id, data) {
    let auto = new Auto()

    for (var key in data) {
      auto.set(key, data[key])
    }

    return this.update(id, auto)
  },
  findCar(plate) {
    return Repository.get(action + '?state_numbers=' + toBD(plate)).then(
      res => {
        if (res.data.items.length === 0) {
          return false
        }
        if (res.data.items.length > 0) {
          return res.data.items[0]
        }
      },
    )
  },
  searchCar(plate) {
    return Repository.get(
      action +
        '?state_numbers=' +
        toBD(plate) +
        '&expand=user,added_org,master-approve',
    )
  },
  searchCarByName(plate) {
    return Repository.get(
      action +
        '?search=' +
        toBD(plate) +
        '&expand=user,added_org,master-approve',
    )
  },
  searchCarByInn(inn) {
    return Repository.get(
      action +
        '?carrier_inn=' +
        toBD(inn) +
        '&expand=user,added_org,master-approve',
    )
  },
  deleteAuto(id) {
    return Repository.delete(action + '/' + id, {
      id,
    })
  },
}
